/**
 * @file API service — vehicleCategoryEmissionFactorsPublicService.
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";

/** Public list item (active rows only; server orders by sortOrder, then id). */
export interface VehicleCategoryEmissionFactorPublic {
  id: number;
  categoryLabel: string;
  emissionFactor: string;
  unit: string;
  sortOrder: number;
}

/** Exported function — fetch Vehicle Category Emission Factors. */
export async function fetchVehicleCategoryEmissionFactors(): Promise<
  VehicleCategoryEmissionFactorPublic[]
> {
  const res = await axiosClient.get<{
    success?: boolean;
    data?: VehicleCategoryEmissionFactorPublic[];
    message?: string;
  }>(API_URLS.VEHICLE_CATEGORY_EMISSION_FACTORS);

  if (res.data?.success === false) {
    throw new Error(
      res.data.message || "Failed to load vehicle category emission factors"
    );
  }
  const data = res.data?.data;
  if (!Array.isArray(data)) return [];
  return [...data].sort((a, b) => {
    const so = (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
    if (so !== 0) return so;
    return (a.id ?? 0) - (b.id ?? 0);
  });
}
